import { render, staticRenderFns } from "./ServiceRequestItems.vue?vue&type=template&id=7068d75e"
import script from "./ServiceRequestItems.vue?vue&type=script&lang=js"
export * from "./ServiceRequestItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports